import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { gsap } from 'gsap';
import Icon from '../shared/Icon';

export default function PRHero() {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const highlights = t('pr.hero.highlights', { returnObjects: true });

  useEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !rootRef.current) return;
    const ctx = gsap.context(() => {
      gsap.from(rootRef.current.querySelectorAll('[data-hero-reveal]'), {
        opacity: 0, y: 22, duration: 0.85, ease: 'power2.out', stagger: 0.08, delay: 0.15,
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={rootRef}
      style={{
        position: 'relative',
        paddingTop: 64 + 96,
        paddingBottom: 96,
        background:
          'linear-gradient(180deg, rgba(5,7,10,0.5) 0%, rgba(5,7,10,0.85) 100%), url("/assets/linhas.webp") center/cover',
        borderBottom: '1px solid var(--p2a-dark-border)',
      }}
    >
      <div className="p2-container" style={{ position: 'relative' }}>
        <div style={{ maxWidth: 820 }}>
          <div className="eyebrow" data-hero-reveal style={{ marginBottom: 20 }}>
            <span className="dot" />{t('pr.hero.eyebrow')}
          </div>
          <h1 className="h-display" data-hero-reveal>
            {t('pr.hero.title_line1')} <span style={{ color: 'var(--p2a-green-400)' }}>{t('pr.hero.title_line2_highlight')}</span>
          </h1>
          <p data-hero-reveal style={{ marginTop: 24, fontSize: 18, lineHeight: 1.55, color: 'var(--p2a-dark-fg-2)', maxWidth: 640 }}>
            {t('pr.hero.p_pre')}
            <strong style={{ color: 'var(--p2a-dark-fg-1)', fontWeight: 600 }}>
              {t('pr.hero.p_strong')}
            </strong>
            {t('pr.hero.p_post')}
          </p>
          <div data-hero-reveal style={{ display: 'flex', gap: 12, marginTop: 32, flexWrap: 'wrap' }}>
            <a
              href="https://api.whatsapp.com/send?phone=5519996542014&text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20uma%20demonstra%C3%A7%C3%A3o%20do%20PixRow."
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              {t('pr.hero.cta_primary')} <Icon.ArrowRight />
            </a>
            <a href="#pipeline" className="btn btn-ghost">
              {t('pr.hero.cta_secondary')} <Icon.ArrowDown />
            </a>
          </div>

          <div
            data-hero-reveal
            style={{
              marginTop: 48, display: 'flex', gap: 32, flexWrap: 'wrap',
              paddingTop: 28, borderTop: '1px solid var(--p2a-dark-border)',
              maxWidth: 720,
            }}
          >
            {highlights.map((x, i) => (
              <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 140 }}>
                <div className="mono" style={{ fontSize: 10, letterSpacing: '0.14em', color: 'var(--p2a-green-400)' }}>{x.k}</div>
                <div style={{ fontSize: 18, fontWeight: 500, color: 'var(--p2a-dark-fg-1)' }}>{x.v}</div>
                <div style={{ fontSize: 13, color: 'var(--p2a-dark-fg-3)' }}>{x.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
